import { AuthorContent } from '@silvertours/back-domain-page';
import {
  WrapperSmall,
  ImageWrapperSmall,
  StyledImageSmall,
  StyledLink,
  AuthorTextSmall,
} from './Author.styles';

const AuthorInTitle = ({ name, image, prefix, role }: AuthorContent) => (
  <WrapperSmall>
    <ImageWrapperSmall>
      {image && (
        <StyledImageSmall src={image.src} alt="" width="40" height="40" />
      )}
    </ImageWrapperSmall>
    <AuthorTextSmall>
      {prefix}&nbsp;
      <StyledLink href="#author">{name}</StyledLink> | {role}
    </AuthorTextSmall>
  </WrapperSmall>
);
export { AuthorInTitle };
